"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const LoadingSkeleton_module_css_1 = __importDefault(require("./LoadingSkeleton.module.css"));
/**
 * Loading Skeletons - https://www.figma.com/file/B7QsnUMTNYJuQRRsAnVr0Q/Snapchat%2B-billing-on-the-web?type=design&node-id=398-24559&mode=design&t=dO5tvZJMX9MzFlTT-4
 */
function LoadingSkeleton({ theme, as: Tag, className, ...baseHtmlProps }) {
    return (
    // @ts-ignore -- this is fine
    (0, jsx_runtime_1.jsx)(Tag, { className: (0, clsx_1.default)(className, {
            [LoadingSkeleton_module_css_1.default.skeletonLight]: theme === "light",
            [LoadingSkeleton_module_css_1.default.skeletonDark]: theme === "dark",
            [LoadingSkeleton_module_css_1.default.skeleton]: !theme,
        }), ...baseHtmlProps }));
}
exports.LoadingSkeleton = LoadingSkeleton;
//# sourceMappingURL=LoadingSkeleton.js.map